if (!customElements.get('instagram-slider')) {
  customElements.define(
    'instagram-slider',
    class InstagramSlider extends HTMLElement {
      connectedCallback() {
        const videos = this.querySelectorAll('video[data-src]:not([data-src=""])');
        if (!videos.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        this.observer = new IntersectionObserver(this.onIntersection.bind(this), { rootMargin: '200px 0px' });
        videos.forEach((video) => this.observer.observe(video));
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      onIntersection(entries) {
        entries.forEach(({ target: video, isIntersecting }) => {
          if (!isIntersecting) {
            video.pause();
            return;
          }

          if (!video.getAttribute('src')) video.src = video.dataset.src;
          video.muted = true;
          video.play().catch(() => {});
        });
      }
    }
  );
}
